import { render, staticRenderFns } from "./WxReply.vue?vue&type=template&id=62efaccc&scoped=true"
import script from "./WxReply.vue?vue&type=script&lang=js"
export * from "./WxReply.vue?vue&type=script&lang=js"
import style0 from "./WxReply.vue?vue&type=style&index=0&id=62efaccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62efaccc",
  null
  
)

export default component.exports